import { connect } from 'react-redux'
import QtEkgReview from './QtEkgReview'
import { getDataSource } from '../../store/appReducer'
import { DATASOURCES } from '../../constants'
import {
  getEkgReviewData,
  handleOnFilterButtonClick,
  handleOnEKGNextClick,
  handleOnSortClick,
  handleOnFilterChange,
  handleOnTabClick,
  handleOnPhysicianInboxChange,
  handleOnProviderInboxChange,
  handleOnRowClick,
  getRecordingIdsFromDataSource,
  handleOnRefreshClick,
  handleOnBulkAction,
  updateSelectedEkgs,
  handleOnSelectionClick,
  handleOnConfirmedMonthClick,
} from './module'

const mapActionCreators = {
  getEkgReviewData,
  handleOnFilterButtonClick,
  handleOnEKGNextClick,
  handleOnSortClick,
  handleOnFilterChange,
  handleOnTabClick,
  handleOnPhysicianInboxChange,
  handleOnProviderInboxChange,
  handleOnRowClick,
  handleOnRefreshClick,
  handleOnBulkAction,
  updateSelectedEkgs,
  handleOnSelectionClick,
  handleOnConfirmedMonthClick,
}

const mapStateToProps = state => ({
  dataIsFetching: state.qtEkgReview.dataIsFetching,
  dataLastUpdated: state.qtEkgReview.dataLastUpdated,
  refreshClicked: state.qtEkgReview.refreshClicked,
  bulkActionComplete: state.qtEkgReview.bulkActionComplete,
  bulkActionIsFetching: state.qtEkgReview.bulkActionIsFetching,
  bulkActionSuccessMessage: state.qtEkgReview.bulkActionSuccessMessage,
  selectedIndex: state.qtEkgReview.selectedIndex,
  selectedPageTab: state.qtEkgReview.selectedPageTab,
  selectedInboxId: state.qtEkgReview.selectedInboxId,
  selectedPatientId: state.qtEkgReview.selectedPatientId,
  selectedEkgResult: state.qtEkgReview.selectedEkgResult,
  selectedPhysicianId: state.qtEkgReview.selectedPhysicianId,
  selectedPhysicians: state.qtEkgReview.selectedPhysicians,
  selectedIntrText: state.qtEkgReview.selectedIntrText,
  selectedPatientText: state.qtEkgReview.selectedPatientText,
  selectedAssignedPhysicians: state.qtEkgReview.selectedAssignedPhysicians,
  selectedQtOrderingPractice: state.qtEkgReview.selectedQtOrderingPractice,
  selectedStartDate: state.qtEkgReview.selectedStartDate,
  selectedEndDate: state.qtEkgReview.selectedEndDate,
  selectedBpmStartValue: state.qtEkgReview.selectedBpmStartValue,
  selectedBpmEndValue: state.qtEkgReview.selectedBpmEndValue,
  selectedQtcfStartValue: state.qtEkgReview.selectedQtcfStartValue,
  selectedQtcfEndValue: state.qtEkgReview.selectedQtcfEndValue,
  selectedConfirmedCurrentMonth: state.qtEkgReview.selectedConfirmedCurrentMonth,
  selectedPopover: state.qtEkgReview.selectedPopover,
  selectedEkgs: state.qtEkgReview.selectedEkgs,
  stackNextResultsToken: state.qtEkgReview.stackNextResultsToken,
  me: getDataSource(state, DATASOURCES.ME),
  ekgs: getDataSource(state, DATASOURCES.EKGS),
  ekgStacks: getDataSource(state, DATASOURCES.EKG_STACKS),
  patients: getDataSource(state, DATASOURCES.PATIENTS),
  physicians: getDataSource(state, DATASOURCES.PHYSICIANS),
  orderingPactices: getDataSource(state, DATASOURCES.ORDERING_PRACTICES),
  ekgStackCounts: getDataSource(state, DATASOURCES.EKG_STACK_COUNTS),

  recordingIds: getRecordingIdsFromDataSource(state),
  sortBy: state.qtEkgReview.sortBy,
  sortDirection: state.qtEkgReview.sortDirection,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(QtEkgReview)



// WEBPACK FOOTER //
// ./src/legacy/pages/QtEkgReview/container.js